function GetGridVal(showRolesByProduct, isEntityPresent) {
  if (showRolesByProduct && isEntityPresent) return 5;
  if (showRolesByProduct && !isEntityPresent) return 6;
  if (!showRolesByProduct && isEntityPresent) return 4;
  return 6;
}

export default GetGridVal;
